import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import PricingPage from "@/pages/PricingPage";
import WhyBankTransfers from "@/pages/WhyBankTransfers";
import WhyPaymentLinks from "@/pages/WhyPaymentLinks";
import WhyVendorsChoose from "@/pages/WhyVendorsChoose";
import CustomerProtection from "@/pages/CustomerProtection";
import LegalPage from "@/pages/LegalPage";
import DeleteAccountData from "@/pages/DeleteAccountData";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import PitchDeck from "@/pages/PitchDeck";
import PitchPrint from "@/pages/PitchPrint";
import InvestorMicrosite from "@/pages/InvestorMicrosite";
import NotFound from "@/pages/NotFound";
import { TERMS, PRIVACY, REFUND, HOW_PAYMENTS } from "@/data/legalContent";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Immersive routes hide the global site chrome (navbar/footer).
function Chrome({ children }) {
  const { pathname } = useLocation();
  const hide = pathname === "/pitch" || pathname.startsWith("/pitch/");
  return (
    <>
      {!hide && <Navbar />}
      {children}
      {!hide && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App min-h-screen bg-white text-[#091630]">
        <Chrome>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/why-workpay/workpay-vs-bank-transfers" element={<WhyBankTransfers />} />
            <Route path="/why-workpay/workpay-vs-payment-links" element={<WhyPaymentLinks />} />
            <Route path="/why-workpay/why-vendors-choose-workpay" element={<WhyVendorsChoose />} />
            <Route path="/why-workpay/customer-protection" element={<CustomerProtection />} />
            <Route path="/terms-and-conditions" element={<LegalPage doc={TERMS} />} />
            <Route path="/privacy-policy" element={<LegalPage doc={PRIVACY} />} />
            <Route path="/delete-account-data" element={<DeleteAccountData />} />
            <Route path="/refund-and-dispute-policy" element={<LegalPage doc={REFUND} />} />
            <Route path="/how-payments-work" element={<LegalPage doc={HOW_PAYMENTS} />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/pitch" element={<PitchDeck />} />
            <Route path="/pitch/print" element={<PitchPrint />} />
            <Route path="/investor" element={<InvestorMicrosite />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Chrome>
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
